// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"37172f91","171":"d58680de","400":"4a196731","699":"547273d0","842":"1d060b55","998":"460956a4"}[chunkId] + ".chunk.js";
};